<template>
  <div class="meta-sources-wrap">
    <el-button type="primary" @click="addMetaSource">{{$t('feed.settings.metaSource.sourceButton')}}</el-button>

    <el-divider></el-divider>

    <el-card shadow="hover" v-if="active" v-loading="loading">
      <el-collapse v-model="activeSource" accordion v-if="sources.length">
        <el-collapse-item :title="source.title" :name="source.title" v-for="(source, sourceId) in sources" :key="source.id">
          <ul class="meta-source-list">
            <template v-for="(item, index) in sourcesDictionary">
              <li class="meta-source-list__item" :key="item.id" v-if="'items' in source">
                <el-input
                  v-for="meta in source.items.filter((it)=> it.network_name == index)"
                  :key="meta.id"
                  style="margin-bottom: 20px"
                  placeholder="Введите источник"
                  v-model="meta.username"
                  :readonly="true">
                  <template slot="prepend"><i :class="`${item.preIcon} fa-${item.icon}`"></i></template>
                  <template slot="suffix"><el-tooltip :content="`Убрать источник`" effect="light" placement="top" :key="index"><i class="el-dialog__close el-icon el-icon-close" @click="delSource(meta.id, sourceId)"></i></el-tooltip></template>
                </el-input>

                <net-source
                  :source="source"
                  :sources-by-net="sourcesByNet[index].filter(i=>source.items.findIndex((item)=> item.inner_id == i.inner_id) == -1).concat(source.items.filter(i=>!sourcesByNet[index].findIndex((item)=> item.inner_id == i.inner_id) == -1))"
                  :net="index"
                  @setSelectedSource="setSelectedSource"
                  :source-name="item.name"
                />

              </li>
              <li class="meta-source-list__item" :key="item.id" v-if="!('items' in source)">
                <net-source
                  :source="source"
                  :sources-by-net="sourcesByNet[index]"
                  :net="index"
                  @setSelectedSource="setSelectedSource"
                  :source-name="item.name"
                />

              </li>
            </template>
          </ul>

          <el-divider></el-divider>

          <div class="meta-sources-button-wrap">
            <el-button :type="getType(source)" @click="toEdit(source)">{{getTitle(source)}}</el-button>
            <el-button type="primary" @click="toSave(source.id)" v-if="!getDisabled(source)">{{$t('feed.settings.metaSource.editForm.saveButton')}}</el-button>
            <el-button type="danger" @click="toDelete(source.id)" style="margin-left: auto">{{$t('feed.settings.metaSource.editForm.deleteButton')}}</el-button>
          </div>

        </el-collapse-item>
      </el-collapse>
    </el-card>
    <el-drawer
      custom-class="source-drawer"
      :visible.sync="metaDrawer"
      :direction="direction"
      size="100%"
      :append-to-body="true"
    >
      <new-meta-source :sourcesDictionary="sourcesDictionary" :sources-by-net="sourcesByNet" @saveNewSource="saveNewSource"/>
    </el-drawer>
  </div>
</template>

<script>
  /*
    Meta source component
  */

  // api
  import { getMetaSourcesApi, getSourcesByNetApi, addMetaItemItemApi, saveMetaItemApi, deleteMetaItemApi, deleteMetaItemItemApi } from "../../../../../api/feeds";

  // components
  import NetSource from './components/NetSource';
  import NewMetaSource from './components/NewMetaSource';

  export default {
    name: 'MetaSource',
    props: {
      active: {
        type: Boolean
      },
    },
    data() {
      return {
        metaDrawer: false,
        direction: 'rtl',
        select: '',
        loading: false,
        isLoaded: false,
        isDisabled: true,
        sources: [],
        sourcesByNet: [],
        start: 0,
        limit: 20,
        activeSource: '',
        selectedSource: [],
        sourcesDictionary: this.$t('feed.settings.metaSource.newSource.form.sourcesDictionary'),
      };
    },
    methods: {
      addMetaSource() {
        this.metaDrawer = !this.metaDrawer;
      },
      getDisabled(source) {
        if (source.disabled === undefined) {
          return true;
        }

        return source.disabled;
      },

      getNetId(net) {
        switch (net) {
          case "vk":
            return 1;
            break;
          case "tg":
            return 5;
            break;
          case "gs":
            return 4;
            break;
          case "tw":
            return 2;
            break;
          case "fb":
            return 3;
            break;
          case "ig":
            return 7;
            break;
          case "yt":
            return 8;
            break;
          case "ok":
            return 10;
            break;
          case "dz":
            return 11;
            break;
          default:
            return "Нет таких значений";
        }
      },

      toEdit(source) {
        console.log("this.sources", this.sourcesDictionary)
        //this.metaDrawer = true;

        if ('items' in source)
        this.setSelectedSource({select: [...source.items].map((it)=>it.inner_id), net: source.items[0].network_name, sourceId: +source.id})
        if (source.disabled === undefined) {
          this.$set(source, 'disabled', false);
        } else {
          source.disabled = !source.disabled;
        }
      },
      setSelectedSource({select, net, sourceId}) {
        console.log("00", select, net, sourceId)
        if (this.selectedSource[sourceId]) {
          console.log("11", select, net, sourceId)
          this.selectedSource[sourceId] = {...this.selectedSource[sourceId], ...{[net]: select.toString()}};
        } else {
          console.log("22", select, net, sourceId)
          this.selectedSource = {[sourceId]: {[net]: select.toString()}};
        }
      },
      getKeyData(sourceId, source) {
        let keysData = {};

        for (let key in this.sourcesDictionary) {
          if (this.selectedSource[sourceId][key]) {
            keysData[key] = this.selectedSource[sourceId][key];
          } else {
            keysData[key] = source[key].id;
          }
        }

        return keysData;
      },
      toSave(sourceId) {
        this.loading = true;
        let source = this.sources.find(item => item.id === sourceId);

        console.log("sourceId",this.selectedSource[sourceId])

        Object.keys(this.selectedSource[sourceId]).map((net)=> {
          this.selectedSource[sourceId][net].split(",").map((item) => {
            let params = {
                  metaitem_id: +sourceId,
                  network_id: this.getNetId(net),
                  source_id: item,
                };
            addMetaItemItemApi(params).then(resp => {
              this.loading = false;
              
              console.log("this.sources", this.sourcesDictionary)
            })
          })
          this.metaDrawer = false;
        });

        /*let params = {
          id: source.id,
          thread_id: this.$route.params.threadId,
          title: source.title,
          ...this.getKeyData(sourceId, source),
          tg: '',
        };

        saveMetaItemApi(params).then(resp => {
          this.sources = this.sources.map(item => {
            if (item.id === resp.data.id) {
              item = {...item, ...resp.data};
            }

            return item;
          });
          this.loading = false;
        });*/

      },
      saveNewSource(id, sources) {
        Object.keys(sources).map((net)=> {
          sources[net].split(",").map((item) => {
            let params = {
                  metaitem_id: +id,
                  network_id: this.getNetId(net),
                  source_id: item,
                };
            addMetaItemItemApi(params).then(resp => {
              if ((this.sources.findIndex((item) => +item.id == +resp.data.id)) == -1) {
              this.sources.push(resp.data)}
              this.loading = false;
              
              console.log("this.sources", this.sourcesDictionary)
            })
          })
          this.metaDrawer = false;
        });
      },
      delSource(id, sourceId) {

        deleteMetaItemItemApi({id}).then(() => {
                this.getSources()
                this.loading = false;
              });
      },
      toDelete(sourceId) {
        this.$alert(`Удалить мета-источник?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.loading = true;

              deleteMetaItemApi({id: sourceId}).then(() => {
                this.sources = this.sources.filter(item => item.id !== sourceId);
                this.loading = false;
              });

            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      getType(source) {
        if (source.disabled === undefined) {
          return 'primary';
        }

        if (source.disabled === false) {
          return '';
        } else {
          return 'primary';
        }
      },
      getTitle(source) {
        if (source.disabled === undefined) {
          return this.$t('feed.settings.metaSource.editForm.editButton');
        }

        if (source.disabled === false) {
          return this.$t('feed.settings.metaSource.editForm.cancelButton');
        } else {
          return this.$t('feed.settings.metaSource.editForm.editButton');
        }
      },
      getSources() {
        this.loading = true;
        this.activeSource = '';

        getMetaSourcesApi({
          thread_id: this.$route.params.threadId,
          start: 0,
          limit: 500,
        }).then(resp => {
          getSourcesByNetApi({thread_id: this.$route.params.threadId}).then(netResp => {
            this.isLoaded = true;
            this.loading = false;

            this.sourcesByNet = netResp.data;
            this.sources = [...resp.data.items];
            this.start = this.sources.length;

            //console.log(resp, netResp);
          });
        });
      }
    },
    watch: {
      active(value) {
        if (value) {
          if (!this.isLoaded) {
            this.getSources();
          }
        }
      },
    },
    components: {
      NetSource,
      NewMetaSource,
    }
  };
</script>

<style>
  .meta-source-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .meta-source-list .el-input-group__prepend {
    width: 35px;
    text-align: center;
  }
  .meta-source-list__item {
    margin-bottom: 20px;
  }
  .meta-source-list .el-select{
    display: block;
  }
  .meta-sources-button-wrap {
    display: flex;
  }
  .source-drawer{
    overflow: auto;
  }
  .el-icon-close {padding: 10px;
    cursor: pointer;}
</style>
